import { render } from "./EventsList.vue?vue&type=template&id=5125359e&scoped=true"
import script from "./EventsList.vue?vue&type=script&lang=js"
export * from "./EventsList.vue?vue&type=script&lang=js"

import "./EventsList.vue?vue&type=style&index=0&id=5125359e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5125359e"

export default script